import axios from "axios";

export const postDeadline = async (date: String) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/Settings/deadline?Date=${date}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
